(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seagreen-wellness-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scoringMap = {
      general_foundation: { general: 4 },
      glp1_gaps: { glp1: 4 },
      superfood_nutrition: { superfood: 4 },
      general_energy: { general: 3 },
      glp1_context: { glp1: 4 },
      superfood_context: { superfood: 4 },
      general_context: { general: 3 },
      superfood_context_2: { superfood: 3, general: 1 },
      glp1_path: { glp1: 5 },
      general_path: { general: 5 },
      superfood_path: { superfood: 5 },
      general_path_2: { general: 4 }
    };

    const results = {
      glp1: {
        title: 'GLP-1 Support',
        copy: 'You may benefit most from deep micronutrient replenishment and steady daily support while on GLP-1.',
        link: '/pages/glp1-support'
      },
      superfood: {
        title: 'Seagreens as a Superfood',
        copy: 'Your path is nutrient-dense, sea-greens-first support to strengthen daily nourishment.',
        link: '/pages/plant-based'
      },
      general: {
        title: 'General Wellbeing',
        copy: 'Your strongest match is consistent daily energy, clarity, and foundational wellness.',
        link: '/pages/premium'
      }
    };

    const allPathKeys = Object.keys(results);

    function initQuiz(root) {
      const track = root.querySelector('[data-track]');
      const panels = root.querySelectorAll('[data-panel]');
      const options = root.querySelectorAll('.seagreen-quiz__option');
      const progressFill = root.querySelector('[data-progress-fill]');
      const progressLabel = root.querySelector('[data-progress-label]');
      const resultTitle = root.querySelector('[data-result-title]');
      const resultCopy = root.querySelector('[data-result-copy]');
      const resultLink = root.querySelector('[data-result-link]');
      const retakeBtn = root.querySelector('[data-retake]');

      let step = 0;
      const answers = [null, null, null];

      const setStep = (nextStep) => {
        step = nextStep;
        track.style.transform = `translateX(-${step * 25}%)`;

        const progressPct = step >= 3 ? 100 : ((step + 1) / 3) * 100;
        progressFill.style.width = `${progressPct}%`;

        if (step >= 3) {
          progressLabel.textContent = 'Result';
        } else {
          progressLabel.textContent = `Question ${step + 1} of 3`;
        }
      };

      const scoreAnswers = () => {
        const scores = allPathKeys.reduce((acc, key) => {
          acc[key] = 0;
          return acc;
        }, {});

        answers.forEach((value) => {
          const rules = scoringMap[value] || {};
          Object.keys(rules).forEach((pathKey) => {
            scores[pathKey] += rules[pathKey];
          });
        });

        const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
        const best = sorted[0] && sorted[0][1] > 0 ? sorted[0][0] : 'general';
        return results[best] || results.general;
      };

      const showResult = () => {
        const result = scoreAnswers();
        resultTitle.textContent = result.title;
        resultCopy.textContent = result.copy;
        resultLink.setAttribute('href', result.link);
        setStep(3);
      };

      options.forEach((button) => {
        button.addEventListener('click', () => {
          const panel = button.closest('[data-question-index]');
          const questionIdx = Number(panel.getAttribute('data-question-index'));
          const value = button.getAttribute('data-value');

          panel.querySelectorAll('.seagreen-quiz__option').forEach((opt) => {
            opt.classList.remove('is-selected');
          });

          button.classList.add('is-selected');
          answers[questionIdx] = value;

          if (questionIdx < 2) {
            setTimeout(() => setStep(questionIdx + 1), 140);
          } else {
            setTimeout(showResult, 140);
          }
        });
      });

      retakeBtn.addEventListener('click', () => {
        answers[0] = null;
        answers[1] = null;
        answers[2] = null;

        panels.forEach((panel) => {
          panel.querySelectorAll('.seagreen-quiz__option').forEach((opt) => {
            opt.classList.remove('is-selected');
          });
        });

        setStep(0);
      });

      setStep(0);
    }

    document.querySelectorAll('.seagreen-quiz').forEach(initQuiz);
  })();

  } catch(e) { console.error(e); }
})();
})();
